import { VIDEO_CODEC } from '../../../react/features/video-quality/constants';
export function getLocalAudioTrackData(track) {
    if (!track) {
        return {
            muted: true,
            isLocalAudioCreated: false
        };
    }
    return {
        muted: track.isMuted(),
        isLocalAudioCreated: true,
        isReceivingData: track.isReceivingData(),
        audioLevel: Number.isFinite(track.audioLevel)
            ? Number.parseFloat(track.audioLevel).toFixed(5) : track.audioLevel,
        stream: {
            active: track.stream?.active
        },
        track: {
            enabled: track.track?.enabled,
            muted: track.track?.muted,
            readyState: track.track?.readyState,
            label: track.track?.label
        }
    };
}
export function getLocalVideoTrackData(localTrack, state) {
    if (!localTrack?.jitsiTrack) {
        return {};
    }
    const { videoQuality } = state['features/base/config'] || {};
    const [defaultVideoCodec = VIDEO_CODEC.AV1] = videoQuality?.codecPreferenceOrder || [];
    const { jitsiTrack } = localTrack;
    const { maxEnabledResolution, resolution } = jitsiTrack;
    return {
        codec: localTrack.codec || defaultVideoCodec,
        maxEnabledResolution,
        resolution,
        isMuted: jitsiTrack.isMuted()
    };
}
